export default __webpack_public_path__ + "static/media/tech-flutter.25af662b.svg";